import React from 'react';
import {format} from 'date-fns'
import PropTypes from 'prop-types';

const BookingDateFormatRenderer = (props) => {
  const date = format(new Date(props.value), "dd-MMM-yyyy h:mm aa")
  return (
    <>{date}</>
  );
};

BookingDateFormatRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)])
};

export default BookingDateFormatRenderer;
